import { useCallback } from 'react'

export function useReplaceImgixUrl(srcUrl: string, targetUrl: string) {
  return useCallback(
    (
      url: string,
      options?: Partial<{
        ratio: string
        quality: number
        width: number
        format: string
        auto: string
      }>
    ) => {
      const {
        ratio = '16:9',
        quality,
        width,
        format = 'webp',
        auto = 'compress'
      } = options ?? {}

      if (!srcUrl || !targetUrl) {
        return url
      }

      const replacedUrl = url.replace(srcUrl, targetUrl)
      if (replacedUrl === url) {
        return url
      }

      const queryString = new URLSearchParams({
        ar: ratio,
        fit: 'crop',
        crop: 'faces,edges',
        auto: auto || '',
        q: quality?.toString() ?? '',
        w: width?.toString() ?? '',
        fm: format
      }).toString()

      return `${replacedUrl}?${queryString}`
    },
    [srcUrl, targetUrl]
  )
}

export default useReplaceImgixUrl
